<script>
export default {
    name: "CareersArrow"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="212.42" height="75.615" viewBox="0 0 212.42 75.615">
        <g id="Group_1488" data-name="Group 1488" transform="translate(-294.719 -1489.421)">
            <g id="Group_1124" data-name="Group 1124" transform="translate(19040.139 -6941.766) rotate(-90)">
                <g id="Group_1121" data-name="Group 1121" transform="translate(-8506.37 -18614.064)">
                    <path id="Path_30" data-name="Path 30" d="M43.53,74.26V0L38.8,8.076,0,74.26V0" transform="translate(15.758 0)" fill="none" stroke="#7c7c7c" stroke-linejoin="round" stroke-width="1"/>
                    <path id="Path_31" data-name="Path 31" d="M0,0H74.175" transform="translate(0.323 15.634)" fill="none" stroke="#7c7c7c" stroke-width="1"/>
                    <path id="Path_32" data-name="Path 32" d="M0,0V64.625" transform="translate(37.475 15.443)" fill="none" stroke="#7c7c7c" stroke-width="1"/>
                    <path id="Path_33" data-name="Path 33" d="M74.75,0,37.457,64.434,0,0" transform="translate(0 15.634)" fill="none" stroke="#7c7c7c" stroke-width="1"/>
                    <path id="Path_34" data-name="Path 34" d="M0,74.26V0L4.734,8.076,43.53,74.26V0" transform="translate(15.758 0)" fill="none" stroke="#7c7c7c" stroke-linejoin="round" stroke-width="1"/>
                </g>
            </g>
            <path id="Path_1195" data-name="Path 1195" d="M15123.684,9989.605h211.424" transform="translate(-14828.965 -8462.375)" fill="none" stroke="#7c7c7c" stroke-width="1"/>
        </g>
    </svg>
</template>